import React from 'react';
import { useContent } from '../../hooks/useContent';
import LoadingSpinner from '../common/LoadingSpinner';
import ErrorMessage from '../common/ErrorMessage';

const Sidebar = () => {
    const { content, isLoading, isError, error, loadContentBySection } = useContent('sidebar');

    // Get the sidebar content data
    const sidebarData = content.length > 0 ? content[0].content_data : null;

    if (isLoading) {
        return (
            <div className="text-center">
                <LoadingSpinner size="lg" />
            </div>
        );
    }

    if (isError) {
        return (
            <div className="text-center">
                <ErrorMessage error={error} onRetry={() => loadContentBySection('sidebar')} />
            </div>
        );
    }

    if (!sidebarData) {
        return (
            <div className="text-center">
                <p>No sidebar content available.</p>
            </div>
        );
    }

    return (
        <div>
            <aside className="sidebar">
                {/* Single Widget */}
                <div className="single-widget">
                    {/* Search Widget */}
                    <div className="widget-content search-widget">
                        <form action="#">
                            <input type="text" placeholder="Enter your keywords" />
                        </form>
                    </div>
                </div>
                {/* Single Widget */}
                <div className="single-widget">
                    {/* Category Widget */}
                    <div className="accordions widget catagory-widget" id="cat-accordion">
                        <div className="single-accordion blog-accordion">
                            <h5>
                                <a role="button" className="collapse show text-uppercase d-block p-3" data-toggle="collapse" href="#accordion1">
                                    {sidebarData.widgetTitle_1}
                                </a>
                            </h5>
                            {/* Category Widget Content */}
                            <div id="accordion1" className="accordion-content widget-content collapse show" data-parent="#cat-accordion">
                                {/* Category Widget Items */}
                                <ul className="widget-items">
                                    {sidebarData.widgetData_1 && sidebarData.widgetData_1.map((item, idx) => (
                                        <li key={`wdo_${idx}`}>
                                            <a href="/#" className="d-flex p-3">
                                                <span>{item.text}</span>
                                                <span className="ml-auto">{item.content}</span>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Single Widget */}
                <div className="single-widget">
                    {/* Post Widget */}
                    <div className="accordions widget post-widget" id="post-accordion">
                        <div className="single-accordion">
                            <h5>
                                <a role="button" className="collapse show text-uppercase d-block p-3" data-toggle="collapse" href="#accordion2">
                                    {sidebarData.widgetTitle_2}
                                </a>
                            </h5>
                            {/* Post Widget Content */}
                            <div id="accordion2" className="accordion-content widget-content collapse show" data-parent="#post-accordion">
                                {/* Post Widget Items */}
                                <ul className="widget-items">
                                    {sidebarData.widgetData_2 && sidebarData.widgetData_2.map((item, idx) => (
                                        <li key={`wdt_${idx}`}>
                                            <a href="/#" className="single-post media p-3">
                                                {/* Post Thumb */}
                                                <div className="post-thumb avatar-md">
                                                    <img className="align-self-center" src={item.image} alt={item.title} />
                                                </div>
                                                <div className="post-content media-body pl-3">
                                                    <p className="post-date mb-3 mb-lg-2">{item.date}</p>
                                                    <h6>{item.title}</h6>
                                                </div>
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Single Widget */}
                <div className="single-widget">
                    {/* Tags Widget */}
                    <div className="accordions widget tags-widget" id="tags-accordion">
                        <div className="single-accordion blog-accordion">
                            <h5>
                                <a role="button" className="collapse show text-uppercase d-block p-3" data-toggle="collapse" href="#accordion3">
                                    {sidebarData.widgetTitle_3}
                                </a>
                            </h5>
                            {/* Tags Widget Content */}
                            <div id="accordion3" className="accordion-content widget-content collapse show" data-parent="#tags-accordion">
                                {/* Tags Widget Items */}
                                <div className="widget-content tags-widget-items pt-2">
                                    {sidebarData.widgetData_3 && sidebarData.widgetData_3.map((item, idx) => (
                                        <a key={`wdth_${idx}`} href="/#" className="d-inline-block mt-2 mr-1 px-2 py-1">
                                            {item.text}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </aside>
        </div>
    );
};

export default Sidebar;